var _rect, _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 114,
    viewBox: "0 0 112 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 114,
    rx: 10,
    fill: "#D8F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.3536 61.3536C65.5488 61.1583 65.5488 60.8417 65.3536 60.6464L62.1716 57.4645C61.9763 57.2692 61.6597 57.2692 61.4645 57.4645C61.2692 57.6597 61.2692 57.9763 61.4645 58.1716L64.2929 61L61.4645 63.8284C61.2692 64.0237 61.2692 64.3403 61.4645 64.5355C61.6597 64.7308 61.9763 64.7308 62.1716 64.5355L65.3536 61.3536ZM50 61.5H65V60.5H50V61.5Z",
    fill: "#30ADE3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1266_8131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 75.25C20.1688 75.25 19.625 74.6875 19.625 74V44C19.625 43.3125 20.1688 42.75 20.8333 42.75H32.9167V49C32.9167 50.3828 33.9966 51.5 35.3333 51.5H41.375V74C41.375 74.6875 40.8313 75.25 40.1667 75.25H20.8333ZM20.8333 39C18.1674 39 16 41.2422 16 44V74C16 76.7578 18.1674 79 20.8333 79H40.1667C42.8326 79 45 76.7578 45 74V51.0703C45 49.7422 44.494 48.4688 43.5878 47.5312L36.7456 40.4609C35.8393 39.5234 34.6159 39 33.332 39H20.8333ZM25.0625 59C24.0581 59 23.25 59.8359 23.25 60.875C23.25 61.9141 24.0581 62.75 25.0625 62.75H35.9375C36.9419 62.75 37.75 61.9141 37.75 60.875C37.75 59.8359 36.9419 59 35.9375 59H25.0625ZM25.0625 66.5C24.0581 66.5 23.25 67.3359 23.25 68.375C23.25 69.4141 24.0581 70.25 25.0625 70.25H35.9375C36.9419 70.25 37.75 69.4141 37.75 68.375C37.75 67.3359 36.9419 66.5 35.9375 66.5H25.0625Z",
    fill: "#30ADE3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1266_8131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.8333 75.25C74.1688 75.25 73.625 74.6875 73.625 74V44C73.625 43.3125 74.1688 42.75 74.8333 42.75H86.9167V49C86.9167 50.3828 87.9966 51.5 89.3333 51.5H95.375V74C95.375 74.6875 94.8313 75.25 94.1667 75.25H74.8333ZM74.8333 39C72.1674 39 70 41.2422 70 44V74C70 76.7578 72.1674 79 74.8333 79H94.1667C96.8326 79 99 76.7578 99 74V51.0703C99 49.7422 98.494 48.4688 97.5878 47.5312L90.7456 40.4609C89.8393 39.5234 88.6159 39 87.332 39H74.8333ZM79.0625 59C78.0581 59 77.25 59.8359 77.25 60.875C77.25 61.9141 78.0581 62.75 79.0625 62.75H89.9375C90.9419 62.75 91.75 61.9141 91.75 60.875C91.75 59.8359 90.9419 59 89.9375 59H79.0625ZM79.0625 66.5C78.0581 66.5 77.25 67.3359 77.25 68.375C77.25 69.4141 78.0581 70.25 79.0625 70.25H89.9375C90.9419 70.25 91.75 69.4141 91.75 68.375C91.75 67.3359 90.9419 66.5 89.9375 66.5H79.0625Z",
    fill: "#30ADE3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1266_8131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.2442 49.7184C83.4309 49.9354 83.4309 50.2879 83.2442 50.5049L79.42 54.9493C79.2333 55.1663 78.93 55.1663 78.7433 54.9493L76.8312 52.7271C76.6445 52.5101 76.6445 52.1577 76.8312 51.9406C77.0179 51.7236 77.3212 51.7236 77.5079 51.9406L79.0824 53.7688L82.569 49.7184C82.7557 49.5014 83.0589 49.5014 83.2457 49.7184H83.2442Z",
    fill: "#30ADE3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1266_8131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 40,
    fill: "white",
    transform: "translate(16 39)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1266_8131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 40,
    fill: "white",
    transform: "translate(70 39)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1266_8131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.69231,
    height: 8.88889,
    fill: "white",
    transform: "translate(76.6924 47.8887)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationManagement);
export default __webpack_public_path__ + "static/media/application_management.b499bede96b5dbdd1f18780bf0ed2386.svg";
export { ForwardRef as ReactComponent };